// @ts-nocheck
/**
 * Shared datetime parse for host helpers and item-variable storage.
 * Accepts finite epoch-ms numbers or ISO-8601 strings; returns epoch ms or null.
 * Numeric strings (e.g. `"1700000000000"`) coerce via `Number` when `Date.parse` fails.
 */

export function parseDateTimeMs(input: unknown): number | null {
  if (typeof input === 'number') {
    return Number.isFinite(input) ? input : null;
  }
  const trimmed = String(input ?? '').trim();
  if (trimmed.length === 0) return null;
  const fromIso = Date.parse(trimmed);
  if (!Number.isNaN(fromIso)) return fromIso;
  const fromNumber = Number(trimmed);
  return Number.isFinite(fromNumber) ? fromNumber : null;
}
